import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { z } from 'zod';

export const isValidPhone = <T extends z.ZodString | z.ZodOptional<z.ZodString>>(
  schema: T,
  message?: string,
) =>
  schema.refine(
    (data) => {
      if (!data) return !(schema instanceof z.ZodString); // skip only if optional
      return parsePhoneNumberFromString(data)?.isValid() ?? false;
    },
    {
      message: message ?? 'Invalid phone number',
    },
  );
